module.exports = __webpack_public_path__ + "img/bg-3@2x.3d498b8f.png";